// src/components/strumenti/VocFreddoFV.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function VocFreddoFV() {
  const [voc, setVoc] = useState("");
  const [coeff, setCoeff] = useState("-0.27");
  const [tempMin, setTempMin] = useState("-10");
  const [numSerie, setNumSerie] = useState("");
  const [vmaxInverter, setVmaxInverter] = useState("");

  const Voc = leggiNumero(voc)||0;
  const beta = leggiNumero(coeff)||0;
  const T = leggiNumero(tempMin);
  const n = parseInt(numSerie)||0;

  const deltaT = T - 25;
  const vocCorretto = Voc * (1 + (beta/100)*deltaT);
  const vocStringa = vocCorretto * n;
  const superaLimite = vmaxInverter && vocStringa > leggiNumero(vmaxInverter);

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Voc pannello a STC (V, da datasheet)</label>
          <input value={voc} onChange={e=>setVoc(e.target.value)} style={inp} placeholder="Es. 41.8"/>
        </div>
        <div>
          <label style={lbl}>Coefficiente temperatura Voc (%/°C)</label>
          <input value={coeff} onChange={e=>setCoeff(e.target.value)} style={inp}/>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Temperatura minima di progetto (°C)</label>
          <input value={tempMin} onChange={e=>setTempMin(e.target.value)} style={inp}/>
        </div>
        <div>
          <label style={lbl}>N° pannelli in serie (stringa)</label>
          <input value={numSerie} onChange={e=>setNumSerie(e.target.value)} style={inp} placeholder="Es. 20"/>
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Vmax DC inverter (V) — facoltativo, per il confronto</label>
        <input value={vmaxInverter} onChange={e=>setVmaxInverter(e.target.value)} style={inp} placeholder="Es. 1000"/>
      </div>

      <div style={{ background: superaLimite ? "#fef2f2" : "#fff7ed", border:`1px solid ${superaLimite?"#fca5a5":"#fed7aa"}`, borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around", marginBottom:10, fontSize:11, color:"#6b7280" }}>
          <div style={{textAlign:"center"}}>
            <div>Voc corretta per pannello</div>
            <div style={{fontWeight:700, color:"#374151", fontSize:14}}>{Voc>0 ? vocCorretto.toFixed(1) : "—"} V</div>
          </div>
        </div>
        <div style={{ textAlign:"center", borderTop:"1px solid #fed7aa", paddingTop:10 }}>
          <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:2 }}>Voc totale stringa a temperatura minima</div>
          <div style={{ fontSize:24, fontWeight:800, color: superaLimite ? "#dc2626" : "#c2410c" }}>
            {n>0 && Voc>0 ? vocStringa.toFixed(1) : "—"}
            <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>V</span>
          </div>
          {superaLimite && (
            <div style={{ fontSize:11, color:"#991b1b", marginTop:6, fontWeight:600 }}>⚠️ Supera il Vmax DC dichiarato dell'inverter — ridurre il numero di pannelli in serie</div>
          )}
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Verifica di sicurezza elettrica (CEI 82-25) — non stima la produzione energetica dell'impianto.
      </div>

      <button onClick={()=>{setVoc("");setCoeff("-0.27");setTempMin("-10");setNumSerie("");setVmaxInverter("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
